import { Link } from 'react-router-dom';
import { isoDay } from './coach-hour-row.js';
import { useMeContext } from '../api/me-provider.js';

/**
 * An MPC coach's own tools, at the top of Home.
 *
 * MOVED FROM ACCOUNT, 11 October 2026. Matthew: "as a coach I want the
 * Availability and today's lessons link to be on my home page not my account
 * page." Home is the first screen after sign-in, and these are the screens a
 * coach opens every day. Today's lessons comes first because it is the one he
 * opens most.
 *
 * Still not in the bottom bar: that bar is a parent's, settled at five on 24
 * September, and a sixth item for the few people who are also coaches would
 * cost every parent the width.
 *
 * Clients, third (mockup *Clients and Texted Links* v8, approved 21 October).
 *
 * A TEAM coach does not get these. Both kinds are the same coach row; only the
 * MPC one sells bookable hours.
 */
export function CoachingRows() {
  const { state } = useMeContext();
  if (state.status !== 'ready' || !state.me.is_mpc_coach) return null;

  return (
    <>
      <span className="section-label">Coaching</span>
      <Link className="hour-row" to={`/lessons?date=${isoDay(new Date())}`}>
        <span className="hour-row-text">
          <span className="name">Today's lessons</span>
          <span className="detail">Who is coming, and what you wrote</span>
        </span>
        <span className="chevron" aria-hidden="true">
          ›
        </span>
      </Link>
      <Link className="hour-row" to="/hours">
        <span className="hour-row-text">
          <span className="name">Availability</span>
          <span className="detail">The hours you are for sale in</span>
        </span>
        <span className="chevron" aria-hidden="true">
          ›
        </span>
      </Link>
      <Link className="hour-row" to="/coach/clients">
        <span className="hour-row-text">
          <span className="name">Clients</span>
          <span className="detail">Your families, and who has signed up</span>
        </span>
        <span className="chevron" aria-hidden="true">
          ›
        </span>
      </Link>
    </>
  );
}
